import { createSlice } from "@reduxjs/toolkit";
import { asyncStatus } from "../../utils/asyncStatus";
import { getReports } from "../../services/ReportService";

const reportSlice = createSlice({
  name: "reports",
  initialState: {
    status: asyncStatus.IDLE,
    reports: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReports.pending, (state) => {
        state.status = asyncStatus.LOADING;
      })
      .addCase(getReports.fulfilled, (state, action) => {
        state.status = asyncStatus.SUCCEEDED;
        // console.log(action.payload, "action.payload");
        state.reports = action.payload?.reports || [];
      })
      .addCase(getReports.rejected, (state, action) => {
        state.status = asyncStatus.FAILED;
        state.error = action.payload;
      });
  },
});

// export const { setIdleStatus } = CustomerManagementSlice.actions;

export default reportSlice.reducer;
